import { render, staticRenderFns } from "./a36.vue?vue&type=template&id=9138d9fe&scoped=true&"
import script from "./a36.vue?vue&type=script&lang=js&"
export * from "./a36.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9138d9fe",
  null
  
)

export default component.exports